import { Box, Flex, Heading, Image, Text } from '@chakra-ui/react';
import logo from 'assets/images/logo.png';
import IFrameViewer from 'components/guest/IFrameViewer';
import { DocumentWithTokenQuery } from 'generated/graphql';
import { useOnCompleted } from './lib';

type Document = DocumentWithTokenQuery['documentWithToken'];

function Esignature({ document }: { document: Document }) {
  useOnCompleted(document);

  if (!document.esignLink) return null;

  return (
    <Flex w="100%" h="100%" direction="column" align="center">
      <Image src={logo} alt="LM logo" boxSize="80px" />
      <Box textAlign="center" mt={4}>
        <Heading as="h4" size="md">
          {document.name}
        </Heading>
        <Text>{document.description}</Text>
      </Box>
      <Box flex={1} p={20} w="100%">
        <IFrameViewer url={document.esignLink} />
      </Box>
    </Flex>
  );
}

export default Esignature;
